import yellow_swirl from "../images/yellow_swirl.png"
import black_swirl from "../images/black_swirl.png" 
import circles from "../images/circles.png"
import basketball from "../images/Basketball.png"
import arrow_shaft from "../images/arrow_shaft.png"
import arrow_tip from "../images/arrow_tip.png"

import React from 'react';
import styled from 'styled-components';

const YellowSwirl = styled.div`
  background-image: url(${yellow_swirl});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 50vw; 
  height: 70vw;
  margin-top: 7vw;
  transform: translateX(-10%);
  z-index: 0;
  position: relative;

  @media screen and (max-width: 426px) {
    margin-top: 60vw;
    width: 60vw; 
  }
`;

const BlackSwirl = styled.div`
  background-image: url(${black_swirl});
  background-size: contain;
  background-repeat: no-repeat;

  width: 60vw; /* Adjusted from 60% to 50% */
  height: 40vw; /* Adjusted from 140vh to 120vh */
  margin-bottom: -12vw;
  margin-top: 5vw;
  transform: translateX(40vw);
  z-index: 0;
  position: relative;
  overflow: hidden;

`;


// Flag container
const Flag = styled.div`
  width: 78vw;
  height: calc(78vw * 0.57513); /* Correctly use calc() for dynamic height based on width */
  display: flex;
  flex-direction: row;
  float: right;
  position: relative;
  z-index: 2;

  @media screen and (max-width: 426px) {
    width: 100%;
    height: 80vw;
  }
`;


// Green vertical rectangle
const RightPanel = styled.div`
  background-color: #122023;
  width: 30%;
  height: calc(100% - 6px);
  float: right;
  display: flex; // To align circles horizontally
  justify-content: left; // Aligns items to the left
  align-items: center; // Centers items vertically
  flex-wrap: wrap; // Allows items to wrap
  position: relative;
  border: 3px solid black; /* Added a 3px black border */

  @media screen and (max-width: 426px) {
    width: 0%;
    height: 0%;
    border: 0px;

  }
`;

// Horizontal rectangles container
const HorizontalPanels = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
  height: calc(100% - 3px);
  position: relative;

  @media screen and (max-width: 426px) {
    width: 100%;

  }
`;

const VerticalPanels = styled.div`
display: flex;
flex-direction: row;
width: 100%;
height: 65%;
position: relative;

@media screen and (max-width: 426px) {
  width: 100%;

}
`;

// Yellow rectangle
const WhitePanel = styled.div`
  background-color: #EFEFEF;
  height: 35%;
  width: 100%;
  display: flex; // Make it a flex container
  align-items: center; // Center items vertically
  justify-content: flex-end; // Align items to the right
  position: relative; // Needed for absolute positioning of children if used
  border: 3px solid black; 

    @media screen and (max-width: 426px) {
    height: 35%;
    width: 100%;
  }
`;

const TitleText = styled.div`  
  height: auto;
  width: 90%;
  display: flex; // Make it a flex container
  text-align: left;
  font-size: 1.8vw;
  font-family: Archivo Narrow;
  font-weight: 400;
  color: #EFEFEF;
  margin-left: 5%;
  margin-top: 5%;


  @media screen and (max-width: 426px) {
    font-size: 3.4vw;
  }

  h1 {
    // justify-content: left;
    color: black;
    font-family: Archivo 800, sans-serif;
    font-size: 7vw;
    font-style: italic;
    line-height: 1.0;
    margin-top: 3.8%;

    @media screen and (max-width: 426px) {
        font-size: 10vw;
      }
  }


`

// Red rectangle
const RedPanel = styled.div`
  background-color: #DF371D; // Red-Orange
  width: 55%;
  height: 100%;
  text-align: center;
  white-space: initial;
  word-wrap: break-word;
  position: relative;
  border: 3px solid black; /* Added a 3px black border */
  border-top: 0px;

  h1 {
    color: white;
    font-family: Archivo Narrow 400, sans-serif;
    font-size: 20px;
  }
`;

const GrayPanel = styled.div`
width: 45%;
height: 100%;
background-color: #A2C1C4;
position: relative; // Add this to position children absolutely within
border: 3px solid black; /* Added a 3px black border */
border-left: 0px;
border-top: 0px;
border-right: 0px;


@media screen and (max-width: 426px) {
  border-right: 3px solid black;
}
`;

const Circle = styled.div`
    background-image: url(${circles});
    height: 5.75%;
    width: 68%;
    margin-left: 0.5vw;
    background-size: cover;
    background-position: center;
`;

const Basketball = styled.div`
  background-image: url(${basketball});
  background-size: cover;
  background-position: center;
  aspect-ratio: 1 / 1; /* Assuming the basketball image is a square */
  width: 25%; /* Example width */
  max-width: 168px; /* Optional: to prevent the image from becoming too large */
  margin-right: 3%;
`;

const ArrowShaft = styled.div`
background-image: url(${arrow_shaft});
height: 77.5%;
width: 77.5%;
bottom: 0; // Align to the bottom of the GrayPanel
position: absolute;
background-size: cover;
background-position: center;
`;

const ArrowTip = styled.div`
background-image: url(${arrow_tip});
height: 36%;
width: 24.8%;
margin-left: 63%;
margin-top: 2%;
background-size: cover;
background-position: center;

`;


export default function Blurb(props) {
  return (
    <> <BlackSwirl />
        <Flag>
          <HorizontalPanels>
              <WhitePanel>
                  {/* Mapping through each blurb item */}
                  {props.data.blurb.map((item, index) => (
                      <TitleText key={index}>
                          <h1 style={{textTransform: "uppercase"}}>
                              {item.blurb_title}
                          </h1>
                      </TitleText>
                  ))}
                  <Basketball />
              </WhitePanel>
              <VerticalPanels>
                  <RedPanel>
                      <TitleText> {props.data.blurb[0].blurb_text} </TitleText>
                  </RedPanel>
                  <GrayPanel>
                      <ArrowShaft />
                      <ArrowTip />
                  </GrayPanel>
              </VerticalPanels>
          </HorizontalPanels>

          <RightPanel>
              {Array.from({ length: 13 }).map((_, index) => (
                  <Circle key={index} />
              ))}
          </RightPanel>
      </Flag>
      <YellowSwirl> </YellowSwirl>
      </>
  );
};

